var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"menu-nav"},[_c('li',{staticClass:"mr-2 menu-search-item"},[_c('div',{staticClass:"custom-search"},[_c('StSearchDefault')],1)]),_c('li',[_c('st-button',{attrs:{"id":"btn_advanced_search","outline":true,"callback":_vm.advancedSearch}},[_vm._v(" "+_vm._s(_vm.$t('MENU.SEARCH_BUTTON'))+" ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }